import { useContext } from 'react'
import { FilterContext } from '@components/Items/Filters/Context'

const useFilter = () => useContext(FilterContext)

export default useFilter
